import { render } from "./CoordinatorDashboard.vue?vue&type=template&id=2f45f844&scoped=true"
import script from "./CoordinatorDashboard.vue?vue&type=script&lang=js"
export * from "./CoordinatorDashboard.vue?vue&type=script&lang=js"

import "./CoordinatorDashboard.vue?vue&type=style&index=0&id=2f45f844&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f45f844"]])

export default __exports__